import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { environment } from "../../../environments/environment";
import { UserService } from "./user.service";

const bypassRoutes = ['/validate', '/company/validate/'];

/**
 * Agrega el token de obra-backend a las peticiones de la API.
 * Si el token venció, lo renueva una sola vez con la sesión Firebase vigente.
 */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor (private userService: UserService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.startsWith(environment.baseURL) || bypassRoutes.some(x => req.url.includes(x))) {
      return next.handle(req);
    }

    const token = this.userService.storedToken();
    if (token) {
      return next.handle(this.withToken(req, token));
    }

    return this.userService.exchangeFirebaseToken().pipe(
      switchMap((result) => {
        if (!result.token) {
          void this.userService.logout();
          return next.handle(req);
        }
        return next.handle(this.withToken(req, result.token));
      })
    );
  }

  private withToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
  }
}
